export default __webpack_public_path__ + "static/lbr-bfb47badde138d3a68e006c2a23a95fb.png";